export const HEADER_HEIGHT = 88;

export const DESKTOP_FOOTER_HEIGHT = 270;
